import React, { useState, useEffect, useContext, useRef } from "react";
import { Row, Col, Spin, Button, Anchor, Typography, Space, Modal, Radio, Drawer } from "antd";
import MenuItem from "./MenuItem";
import { PublicContext } from "../PublicContext";
import "../../styles/custom.css";
import HotPepperIcon from '../HotPepperIcon';
import PromoCarousel from "./PromoCarousel";
import MenuPromoSingle from "./MenuPromoSingle";
import { Link, useLocation } from "react-router-dom";
import UpsellUtensilModal from "./UpsellUtensilModal";

export default function MenuVertical() {
    const { Paragraph, Title } = Typography;
    const [categories, setCategories] = useState([]);
    const location = useLocation();
    const {
        promotions,
        stores,
        productCategories,
        promotionProducts,
        products,
        storeProducts,
        cartNum,
        cartPrice,
        cart,
        loading,
        isAbove991px,
        sideCartVisible,
        setSideCartVisible,
        selectedStore,
        menuUrl,
        setMenuUrl,
        setDeliveryOrPickUp
    } = useContext(PublicContext);
    const [selectedPromo, setSelectedPromo] = useState();
    const [menuItem, setMenuItem] = useState({
        productName: "",
        price: 0,
        description: "",
        pictureURL: "https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/img-placeholder.png",
    });
    const [openDrawer, setOpenDrawer] = useState(false);
    const [showFloatingButton, setShowFloatingButton] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [upsellModalVisible, setUpsellModalVisible] = useState(false);
    const [drawerVisible, setDrawerVisible] = useState(false);

    const categoryRefs = useRef({});
    const [activeCategory, setActiveCategory] = useState(null);

    const handleModalClose = () => {
        setModalVisible(false);
    };

    const handleUpsellUtensilModalClose = () => {
        setUpsellModalVisible(false);
    };

    const handleSideCartClickAway = (event) => {
        // Check if the clicked element is outside the fixed div
        if (!event.target.closest('.viewCartBtn') &&
            !event.target.closest('.floatingCartBtn') &&
            !event.target.closest('.menu-cart-nav') &&
            !event.target.closest('#sideCart')
        ) {
            setSideCartVisible(false);
        }
    };

    const [selectedStoreCode, setSelectedStoreCode] = useState(() => {
        const selectedStoreJSON = sessionStorage.getItem("selectedStore");
        if (selectedStoreJSON) {
            const store = stores.find(store => store.storeCode === JSON.parse(selectedStoreJSON).storeCode);
            return store ? store.storeCode : '';
        }
        return '';
    });

    useEffect(() => {
        getStore();

        const handleScroll = () => {
            const scrollY = window.scrollY;
            if (scrollY > 184) {
                setShowFloatingButton(true);
            } else {
                setShowFloatingButton(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        document.body.addEventListener('click', handleSideCartClickAway);

        return () => {
            window.removeEventListener('scroll', handleScroll);
            document.body.removeEventListener('click', handleSideCartClickAway);
        };
    }, []);

    function selectMenuItem(item, promo) {
        setSelectedPromo(promo);
        setMenuItem(item);
        setOpenDrawer(true);
    }

    function getStore() {
        populateProductCategories();
    }

    const handleNavbarStoreCardClick = () => {
        //navigate('locationsmap');
        //console.log("clicked handleNavbarStoreCardClick");
        setModalVisible(true);
    }

    function renderDrawer() {
        return (
            <MenuItem
                menuItemProp={menuItem}
                selectedPromo={selectedPromo}
                setOpenDrawer={setOpenDrawer}
            />
        );
    }

    function renderPromotionTag(productCode) {
        if (promotionProducts.some((pp) => pp.buyProductCode === productCode)) {
            const pps = promotionProducts.find(
                (pp) => pp.buyProductCode === productCode
            );
            //console.log(pps);
            //console.log(promotions);
            const ps = promotions.find((p) => p.id === pps.promotionId);
            //console.log(ps);
            //return (
            //    <div
            //        style={{
            //            position: "absolute",
            //            top: "8px",
            //            left: "8px",
            //            borderRadius: "6px",
            //            backgroundColor: "#38803d",
            //            color: "white",
            //            padding: "4px",
            //            zIndex: 2,
            //        }}
            //    >
            //        {ps.promotionName}
            //    </div>
            //);
            return (
                //<div
                //    style={{
                //        color: "#38803d",
                //    }}
                //>
                <>
                    {ps.promotionName}
                </>
                //</div>
            );
        }
    }

    async function populateProductCategories() {
        //console.log("populate product categories");
        let data = productCategories.filter(category => category.displayOrder !== -1).sort((a, b) => a.displayOrder - b.displayOrder);

        //console.log(data);

        const wholeOrderPromotions = promotions.filter(item => item.isWholeOrder === true);
        //console.log(wholeOrderPromotions);
        const filteredPromotions = promotions.filter(item => item.isWholeOrder === false);

        //console.log(filteredPromotions);

        const convertedObjects = filteredPromotions.map(item => ({
            id: item.id + 1000,
            categoryName: item.promotionName,
            categoryDescription: item.promotionDescription
        }));

        //console.log(convertedObjects);

        const mainPromotions = [
            { id: 100, categoryName: "Promotions", categoryDescription: "" },
            // Add more rows as needed
        ];

        //console.log(mainPromotions);
        if (wholeOrderPromotions.length > 0 && filteredPromotions.length > 0) {
            // Both types of promotions are present, merge and add both
            //console.log("Both types of promotions are present");
            data = [...mainPromotions, ...convertedObjects, ...data];
        } else {
            if (wholeOrderPromotions.length > 0) {
                //console.log("wholeOrderPromotions.length > 0")
                data = [...mainPromotions, ...data];
            }
            if (filteredPromotions.length > 0) {
                //console.log("filteredPromotions.length > 0");
                data = [...convertedObjects, ...data];
            }
        }

        //console.log(data);

        setCategories(data);
    }

    function renderLoading() {
        return <Spin />;
    }

    function renderMenu() {
        return (
            <Row>
                <Col className="displayNone" span={24}>
                    {/*<a href="menu#categoryMenu15">menu 15</a>*/}
                </Col>
                {isAbove991px ?
                    <Col span={6} className="verticalCategory">
                        {renderCategories()}
                    </Col>
                    :
                    <Col span={24} className="horizontalCategory">
                        {/*{renderHorizontalCategories()}*/}
                        <CustomHorizontalAnchor categories={categories} />
                    </Col>
                }
                <Col xs={24} sm={24} md={24} lg={18} style={{ padding: "10px" }}>
                    {renderProducts()}
                </Col>
            </Row>
        );
    }

    function ProductImage({ src, alt }) {
        const [imageExists, setImageExists] = useState(true); // Initially assume image exists

        useEffect(() => {
            // Create a new Image object
            const img = new Image();
            // Set the src attribute to the provided URL
            img.src = src;

            // Event handler to check if the image was loaded successfully
            const handleImageLoad = () => {
                setImageExists(true);
                // Clean up event listeners
                img.onload = null;
                img.onerror = null;
            };
            img.onload = handleImageLoad;

            // Event handler to check if there was an error loading the image
            const handleImageError = () => {
                setImageExists(false);
                // Clean up event listeners
                img.onload = null;
                img.onerror = null;
            };
            img.onerror = handleImageError;
        }, [src]);

        // Render the image only if it exists
        return imageExists ?
            <img
                alt={alt}
                src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(src)}`}
                className="rounded-3 menuProductHorizontalImg"
            />
            :
            null;
    }

    function renderCategories() {
        //console.log("render vertical product catagory");
        return (
            <Anchor
                style={{ overflowY: 'auto', marginBlockStart: '0px' }}
                items={
                    categories.map((category) => {
                        const urlParts = window.location.href.split('#');
                        const baseUrl = urlParts[0];
                        const href = baseUrl + '#categoryMenu' + category.id;
                        return {
                            key: 'v_category_' + category.id,
                            href: href,
                            title: category.categoryName
                        }
                    })
                }
            />
        );
    }

    const showDrawer = () => {
        setDrawerVisible(true);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
    };

    const handleDrawerClick = (href) => {
        window.location.href = href;
        closeDrawer();
    };

    const anchorItems = categories.map((category) => {
        const urlParts = window.location.href.split('#');
        const baseUrl = urlParts[0];
        const href = baseUrl + '#categoryMenu' + category.id;
        return {
            key: 'h_category_' + category.id,
            href: href,
            title: category.categoryName
        }
    });

    function renderHorizontalCategories() {
        //console.log("render horizontal product catagory");
        const scrollToCategory = (id) => {
            const element = categoryRefs.current[id];
            if (element) {
                const rect = element.getBoundingClientRect();
                const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
                const elementLeftPosition = rect.left + scrollLeft;

                window.scrollTo({
                    left: elementLeftPosition - 20, // Adjust offset as needed
                    behavior: 'smooth',
                });

                setActiveCategory(id);
            }
        };

        return (
            //<Anchor
            //    className="hCategoryAnchor"
            //    direction="horizontal"
            //    targetOffset={50}
            //    bounds={50}
            //    offsetTop={46}
            //    items={
            //        categories.map((category) => {
            //            const urlParts = window.location.href.split('#');
            //            const baseUrl = urlParts[0];
            //            const href = baseUrl + '#categoryMenu' + category.id;
            //            return {
            //                key: 'h_category_' + category.id,
            //                href: href,
            //                title: category.categoryName
            //            }
            //        })
            //    }
            ///>

            <div>
                <div className="horizontal-menu">
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            className={`horizontal-menu-item ${activeCategory === category.id ? 'active' : ''}`}
                            onClick={() => scrollToCategory(category.id)}
                        >
                            {category.categoryName}
                        </div>
                    ))}
                </div>
                <div>
                    {categories.map((category) => (
                        <div
                            key={category.id}
                            ref={(el) => (categoryRefs.current[category.id] = el)}
                            id={`categoryMenu${category.id}`}
                            className="content-section"
                        >
                            <h2>{category.categoryName}</h2>
                            <p>Content for {category.categoryName}</p>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    //const CustomHorizontalAnchor = ({ categories }) => {
    //    const [drawerVisible, setDrawerVisible] = useState(false);
    //    const [activeAnchor, setActiveAnchor] = useState(null);

    //    useEffect(() => {
    //        const handleScroll = () => {
    //            categories.forEach((category) => {
    //                const element = document.getElementById(`categoryMenu${category.id}`);
    //                if (element) {
    //                    const rect = element.getBoundingClientRect();
    //                    if (rect.top >= 0 && rect.top <= window.innerHeight / 2) {
    //                        setActiveAnchor(category.id);
    //                    }
    //                }
    //            });
    //        };

    //        window.addEventListener('scroll', handleScroll);
    //        return () => window.removeEventListener('scroll', handleScroll);
    //    }, [categories]);

    //    const handleAnchorClick = (category) => {
    //        setActiveAnchor(category.id);
    //        const element = document.getElementById(`categoryMenu${category.id}`);
    //        if (element) {
    //            element.scrollIntoView({ behavior: 'smooth' });
    //        }
    //    };

    //    const toggleDrawer = () => {
    //        setDrawerVisible(!drawerVisible);
    //    };

    //    return (
    //        <div className="custom-horizontal-anchor">
    //            <Button className="toggle-drawer-button" onClick={toggleDrawer}>
    //                Categories
    //            </Button>
    //            <Drawer
    //                title="Menu Categories"
    //                placement="left"
    //                closable={true}
    //                onClose={toggleDrawer}
    //                visible={drawerVisible}
    //                width={300}
    //            >
    //                <ul className="drawer-category-list">
    //                    {categories.map((category) => (
    //                        <li
    //                            id={`anchorLink${category.id}`}
    //                            key={category.id}
    //                            onClick={() => {
    //                                handleAnchorClick(category);
    //                                toggleDrawer();
    //                            }}
    //                            className={activeAnchor === category.id ? 'active' : ''}
    //                        >
    //                            {category.categoryName}
    //                        </li>
    //                    ))}
    //                </ul>
    //            </Drawer>
    //            <div className="horizontal-anchor-container">
    //                <ul className="horizontal-anchor-list">
    //                    {categories.map((category) => (
    //                        <li
    //                            key={category.id}
    //                            onClick={() => handleAnchorClick(category)}
    //                            className={activeAnchor === category.id ? 'active' : ''}
    //                        >
    //                            {category.categoryName}
    //                        </li>
    //                    ))}
    //                </ul>
    //            </div>
    //        </div>
    //    );
    //};

    const CustomHorizontalAnchor = ({ categories }) => {
        const [drawerVisible, setDrawerVisible] = useState(false);
        const [activeAnchor, setActiveAnchor] = useState(null);
        const isAnchorClickInProgress = useRef(false);
        const anchorListRef = useRef(null);

        useEffect(() => {
            const handleScroll = () => {
                if (!isAnchorClickInProgress.current) {
                    let closestCategory = null;
                    let closestDistance = Infinity;

                    categories.forEach((category) => {
                        const element = document.getElementById(`categoryMenu${category.id}`);
                        if (element) {
                            const rect = element.getBoundingClientRect();
                            if (rect.bottom > 100) {  // Element is at least partially in view
                                const distance = Math.abs(rect.bottom);
                                if (distance < closestDistance) {
                                    closestDistance = distance;
                                    closestCategory = category;
                                }
                            }
                        }
                    });

                    if (closestCategory) {
                        const activeLink = document.getElementById(`anchorLink${closestCategory.id}`);
                        if (activeLink && anchorListRef.current) {
                            activeLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                        }
                        setActiveAnchor(closestCategory.id);
                    }
                }
            };

            window.addEventListener('scrollend', handleScroll);
            return () => window.removeEventListener('scrollend', handleScroll);
        }, [categories]);

        const handleAnchorClick = (categoryId) => {
            isAnchorClickInProgress.current = true;
            const element = document.getElementById(`categoryMenu${categoryId}`);
            if (element) {
                const headerOffset = 100;
                const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementPosition - headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });

                const scrollDone = setInterval(function () {
                    const bounds = element.getBoundingClientRect();

                    if (bounds.top < headerOffset + 5 && bounds.top > headerOffset - 5) {
                        const activeLink = document.getElementById(`anchorLink${categoryId}`);
                        if (activeLink && anchorListRef.current) {
                            activeLink.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
                        }

                        clearInterval(scrollDone);

                        isAnchorClickInProgress.current = false;
                    }
                }, 50);

                setActiveAnchor(categoryId);
            }
        };

        const toggleDrawer = () => {
            setDrawerVisible(!drawerVisible);
        };

        return (
            <div className="custom-horizontal-anchor">
                <div className="horizontal-anchor-container" ref={anchorListRef}>
                    <Button className="toggle-drawer-button" onClick={toggleDrawer}>
                        <div className="hamburger-icon">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </Button>
                    <ul className="horizontal-anchor-list">
                        {categories.map((category) => (
                            <li
                                id={`anchorLink${category.id}`}
                                key={category.id}
                                onClick={() => handleAnchorClick(category.id)}
                                className={activeAnchor === category.id ? 'active' : ''}
                            >
                                {category.categoryName}
                            </li>
                        ))}
                    </ul>
                </div>
                <Drawer
                    title="Menu Categories"
                    placement="bottom"
                    closable={true}
                    onClose={toggleDrawer}
                    visible={drawerVisible}
                    width={300}
                >
                    <ul className="drawer-category-list">
                        {categories.map((category) => (
                            <li
                                key={category.id}
                                onClick={() => {
                                    handleAnchorClick(category.id);
                                    toggleDrawer();
                                }}
                                className={activeAnchor === category.id ? 'active' : ''}
                            >
                                {category.categoryName}
                            </li>
                        ))}
                    </ul>
                </Drawer>
            </div>
        );
    };

    function renderProducts() {
        //console.log("render product table");
        return (
            categories.map((category) => {
                if (category.id === 100) {
                    return (
                        <div id={"categoryMenu" + category.id} key={"categoryMenuKey" + category.id} className="menuCategories">
                            <h2 className="menuCategoriesTitle">{category.categoryName}</h2>
                            {/*<div style={{ paddingLeft: "15px" }}>*/}
                            <PromoCarousel />
                            {/*</div>*/}
                        </div>
                    );
                }
                else if (category.id >= 1000) {
                    return (
                        <div id={"categoryMenu" + category.id} key={"categoryMenuKey" + category.id} className="menuCategories">
                            <h2 className="menuCategoriesTitle">{category.categoryName}</h2>
                            <MenuPromoSingle promoId={category.id - 1000} />
                        </div>
                    );
                }
                else {
                    return (
                        <div id={"categoryMenu" + category.id} key={"categoryMenuKey" + category.id} className="menuCategories">
                            <h2 className="menuCategoriesTitle">{category.categoryName}</h2>
                            <Row>
                                {products.map((product) => {
                                    //console.log(product);
                                    //console.log(selectedStoreCode);
                                    if (product.productCategoryId === category.id && product.isActive && storeProducts.find(sp => sp.productCode === product.productCode && sp.storeCode === selectedStoreCode && sp.isActive)) {
                                        const promoProduct = promotionProducts.find(pp => pp.buyProductCode === product.productCode);
                                        var storeProduct = storeProducts.find(sp => sp.productCode === product.productCode && sp.storeCode === selectedStoreCode && sp.isActive);
                                        var promo = null;
                                        if (promoProduct) {
                                            promo = promotions.find(
                                                (p) => p.promotionType === "BuyXGetY" && p.id === promoProduct.promotionId
                                            );
                                        }
                                        return (
                                            <Col
                                                key={"menuProductCol" + product.id}
                                                className="gutter-row menuProductCol"
                                                xs={24}
                                                sm={24}
                                                md={12}
                                                lg={12}
                                                xl={12}
                                            >
                                                <div className="menuProductHorizontal"
                                                    onClick={() => {
                                                        if (window.gtag) {
                                                            window.gtag('event', 'OpenProduct', {
                                                                event_category: 'Product',
                                                                event_label: 'OpenProduct: ' + product.productName,
                                                            });
                                                        }
                                                        if (storeProduct.isInStock) {
                                                            selectMenuItem(product, promo);
                                                        }
                                                    }}
                                                >
                                                    {!storeProduct.isInStock && (
                                                        <div className="overlay">
                                                            <span className="overlay-text">Out of Stock</span>
                                                        </div>
                                                    )}
                                                    <div className="menuProductHorizontalText">
                                                        <Row>
                                                            <Paragraph ellipsis={true ? { rows: 2 } : false} className="text-black flex-wrap productName">
                                                                {product.productName} <HotPepperIcon value={product.spiciness} />
                                                            </Paragraph>
                                                        </Row>
                                                        <Row>
                                                            <Paragraph ellipsis={true ? { rows: 2 } : false} className="text-black flex-wrap productDescription">
                                                                {product.description}
                                                            </Paragraph>
                                                        </Row>
                                                        <Row>
                                                            <Title tag="h6" level={5} className="mb-0">
                                                                ${product.price.toFixed(2)}
                                                            </Title>
                                                        </Row>
                                                        <Row>
                                                            <Title tag="h6" level={5} className="mb-0">
                                                                {product.calorie}
                                                            </Title>
                                                        </Row>
                                                        <Row>
                                                            <Paragraph ellipsis={true ? { rows: 1 } : false} className="text-black flex-wrap productPromotion">
                                                                {renderPromotionTag(product.productCode)}
                                                            </Paragraph>
                                                        </Row>
                                                    </div>
                                                    {/*<Col xs={5} sm={5} md={5} className="w-100 cart-item-col">*/}
                                                    {/*    <Title tag="h6" level={5} className="mb-0">*/}
                                                    {/*        ${product.price.toFixed(2)}*/}
                                                    {/*    </Title>*/}
                                                    {/*</Col>*/}

                                                    <div className="menuProductHorizontalImg">
                                                        <img
                                                            alt={product.productName}
                                                            src={`https://takeoutpictures.blob.core.windows.net/weborderpictures/medium/${encodeURIComponent(product.pictureURL)}`}
                                                            // fluid
                                                            className="rounded-3 menuProductHorizontalImg"
                                                            onError={({ currentTarget }) => {
                                                                currentTarget.style.display = 'none';
                                                            }}
                                                        />
                                                        <div style={{ marginTop: "-25px", marginLeft: "5px", position: "absolute" }}></div>
                                                    </div>
                                                </div>
                                            </Col>
                                        );
                                    } else {
                                        return null;
                                    }
                                })}
                            </Row>
                        </div>
                    )
                }
            })
        );
    }

    function renderMobileCartButton() {
        return (
            <>
                {cart?.length > 0 ?
                    <Button
                        className="viewCartBtn btn-primary"
                        onClick={() => {
                            if (!sideCartVisible) {
                                setSideCartVisible(true);
                            }
                            else {
                                setSideCartVisible(false);
                                setUpsellModalVisible(true);
                                //navigate("/cart");
                            }
                        }
                        }
                    >
                        {
                            sideCartVisible ?
                                <>
                                    Go To Checkout ({cartNum}) • ${cartPrice}
                                </>
                                :
                                <>
                                    View Cart ({cartNum}) • ${cartPrice}
                                </>
                            //- { cartNum } {cartNum <= 1 ? 'Item' : cartNum > 1 ? 'Items' : ''}
                        }
                    </Button>
                    :
                    <></>
                    //<Button
                    //    className="viewCartBtn btn-primary"
                    //    style={{ backgroundColor: "black" }}
                    //    onClick={() => {
                    //        if (!sideCartVisible) {
                    //            setSideCartVisible(true);
                    //        }
                    //        else {
                    //            setSideCartVisible(false);
                    //            navigate("/cart");
                    //        }
                    //    }}
                    //>
                    //    Cart Is Empty
                    //</Button>
                }
            </>
        )
    }

    function renderFloatingCartButton() {
        return (
            <Button
                className="floatingCartBtn btn-primary"
                shape="round"
                onClick={() => setSideCartVisible(true)}
            >
                View Cart ({cartNum}) • ${cartPrice}
            </Button>
        )
    }

    const DeliveryModal = ({ visible, onClose }) => {
        const [deliveryOption, setDeliveryOption] = useState(sessionStorage.getItem("deliveryOrPickUp") || 'delivery');

        const handleOptionChange = (e) => {
            setDeliveryOption(e.target.value);
        };

        const handleModalClose = () => {
            //setModalVisible(false);
            setDeliveryOrPickUp(deliveryOption);
            sessionStorage.setItem("deliveryOrPickUp", deliveryOption);
            onClose();
        };

        const handleModalConfirm = () => {
            //setModalVisible(false);
            setDeliveryOrPickUp(deliveryOption);
            sessionStorage.setItem("deliveryOrPickUp", deliveryOption);
            onClose();
        };

        return (
            <Modal
                title="Choose Order Type"
                visible={visible}
                onCancel={handleModalClose}
                footer={[
                    <Button key="cancel" onClick={handleModalClose}>
                        Cancel
                    </Button>,
                    <Button key="confirm" type="primary" className="btn-primary" onClick={handleModalConfirm}>
                        Confirm
                    </Button>,
                ]}
            >
                <Radio.Group onChange={handleOptionChange} value={deliveryOption}>
                    <Radio className="custom-radio" value="delivery">Delivery</Radio>
                    <Radio className="custom-radio" value="pickup">Pick Up</Radio>
                </Radio.Group>
            </Modal>
        );
    };

    return (
        <div>
            {/*{(!loading && urlDecoded) ?*/}
            {/*{*/}
            {/*    selectedStoreCode === "BR" &&*/}
            {/*    <>*/}
            {/*        <Title level={3}>Sorry for the inconvenience, the Brampton location is temporarily closed from Monday Sep 16 to Thursday Sep 19.</Title>*/}
            {/*        <Title level={3}>We will reopen on Friday Sep 20.</Title>*/}
            {/*        <Title level={3}>You can still place orders for the future normally.</Title>*/}
            {/*        <Title level={3}>Thank you for your understanding.</Title>*/}
            {/*    </>*/}
            {/*}*/}
            {!loading ?
                (
                    <div>
                        {renderMenu()}
                    </div>
                )
                :
                renderLoading()
            }
            {renderMobileCartButton()}
            {cart?.length && showFloatingButton && !sideCartVisible > 0 ? renderFloatingCartButton() : <></>}
            {openDrawer && renderDrawer()}
            <DeliveryModal visible={modalVisible} onClose={handleModalClose} />
            <UpsellUtensilModal visible={upsellModalVisible} onClose={handleUpsellUtensilModalClose} />
        </div>
    );
}